import React from 'react';
import PageHeaderCompShowcase from '../Views/PageHeaderCompShowcase';

/**
 * MultimediaCompDemoView - Route component for the Multimedia Comp Showcase
 * Simple wrapper that renders the MultimediaCompDemo component
 */
const PageHeaderCompShowcaseView = () => {
  return <PageHeaderCompShowcase />;
};

export default PageHeaderCompShowcaseView;
